module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon1.png?e39ee87a";